var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Backdrop, Button, fade, makeStyles } from '@material-ui/core';
import CircularProgress from "@material-ui/core/CircularProgress";
import clsx from 'clsx';
import React from 'react';
import { useSound } from '../../audio-engine';
import { UIText } from '../ui-text/ui-text';
var useStyles = makeStyles(function (_a) {
    var palette = _a.palette;
    return ({
        root: {
            position: 'relative',
            textTransform: 'none'
        },
        text: {
            fontWeight: 600
        },
        btnSecondary: {
            color: palette.common.white,
            backgroundColor: palette.background.level1,
            '&:hover': {
                backgroundColor: fade(palette.background.level1, 0.75),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: palette.background.level1,
                },
            },
        },
        backdrop: {
            position: 'absolute',
            zIndex: 'initial'
        }
    });
});
export var UIButton = React.forwardRef(function (_a, ref) {
    var _b = _a.variant, variant = _b === void 0 ? 'secondary' : _b, className = _a.className, onClick = _a.onClick, disabled = _a.disabled, controlledLoading = _a.loading, children = _a.children, rest = __rest(_a, ["variant", "className", "onClick", "disabled", "loading", "children"]);
    var classes = useStyles();
    var playSound = useSound();
    var isMountedRef = React.useRef(true);
    var _c = React.useState(false), loading = _c[0], setLoading = _c[1];
    var realLoading = controlledLoading !== null && controlledLoading !== void 0 ? controlledLoading : loading;
    React.useEffect(function () {
        isMountedRef.current = true;
        return function () {
            isMountedRef.current = false;
        };
    }, []);
    var onClickWrapper = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        playSound('buttonClick');
        if (!onClick) {
            return;
        }
        var result = onClick.apply(void 0, args);
        if (result instanceof Promise) {
            setLoading(true);
            result.finally(function () {
                if (isMountedRef.current) {
                    setLoading(false);
                }
            });
        }
    };
    return (React.createElement(Button, __assign({ ref: ref, className: clsx(classes.root, className), classes: { containedSecondary: classes.btnSecondary }, variant: 'contained', color: variant, size: 'large', onClick: onClickWrapper, disabled: disabled || realLoading }, rest),
        React.createElement(UIText, { className: classes.text, variant: 'body1', component: 'div' },
            children,
            React.createElement(Backdrop, { className: classes.backdrop, open: realLoading },
                React.createElement(CircularProgress, { size: '1em', color: 'inherit' })))));
});
